import styled from 'styled-components';

export default styled.div`
  position: fixed;
  z-index: 110;
  display: ${props => (props.visible ? 'block' : 'none')};
`;
